import { cn } from '@app/utils/cn';

import { Skeleton } from '../Skeleton';

import { AttributeRow } from './AttributeRow';

interface Props {
  attributes: { name: string; value: string; key?: string }[];
  isLoading?: boolean;
  skeletonRows?: number;
  containerClassName?: string;
  shouldClampText?: boolean;
  isCompact?: boolean;
}

export const AttributesList = ({
  attributes,
  containerClassName,
  shouldClampText = false,
  isLoading = false,
  skeletonRows = 1,
  isCompact = false,
}: Props) => {
  if (isLoading) {
    return (
      <div className="mb-0.5 columns-3xs gap-10">
        <Skeleton type="text" rows={skeletonRows} size="xsmall" width={50} itemClassName="break-inside-avoid-column my-1.5" />
      </div>
    );
  }

  return (
    <dl className={cn('columns-3xs gap-10', containerClassName)}>
      {attributes.map(({ name, value, key }) => (
        <AttributeRow key={key ?? name} name={name} value={value} shouldClampText={shouldClampText} isCompact={isCompact} />
      ))}
    </dl>
  );
};
